import React, { Component } from 'react';

class Kurser extends Component {

  render () {
    return (
            <center>
      <div className="info" style={{"text-align": "left"}}>
<center><h1>Kurser på folkmusikkaféet</h1></center>
<br/>
<center>
  <small>Deltagare i fredagskurser erhåller 50% rabatt på konsertkvällar så länge kursen pågår.<br/>
    U & S = Ungdomar upp till 25 år samt studerande.</small>
</center>
<br/><br/>
<center>
<img className="kursbild-mindre fade-in-fast" style={{"padding-right": "40px" }}src="img/arkiv/jon_olov.jpg"></img>
<img className="kursbild-mindre fade-in-fast" src="img/arkiv/dan_palmqvist_small.jpg"></img>
</center><br/>
<center><h3>Spelmanslaget</h3></center>
<center>
<div className="kompakt">
Kursen hålls fredagar kl 17:30 - 19:15 med start 19 januari och omfattar hela våren och alla med akustiska instrument är välkomna.
Vi ser gärna att du har något eller några års erfarenhet på ditt instrument. Som kompmusiker ser vi helst att du är relativt självständig och kan lite grunder i folkmusik.<br/><br/>
Kursinstruktör: Jon-Olov Woxlin och Dan Palmqvist <br/><br/>
Kostnad: 600 kr (u&s 350 kr) betalas in på pg 107741-1 eller Swish 1236085450. Ange namn + "spelmanslaget".<br/><br/>
<small>För mer information: Dan Palmqvist, dan.palmqst@gmail.com</small>
       </div>
</center>
  <center>
    <h3>Nybörjarkurs i dans</h3>
  </center>
  <center>
    Danskurs på Folkmusikkaféet,<br/><small>fyra fredagskvällar 2/2 – 23/2, kl 18:00 –19:30</small><br/><br/>
<div className="kompakt">
Vi lär oss och tränar grunderna i pardanser som polska, slängpolska, vals och schottis samt i
engelska, där man danser flera par tillsammans. Dessa danser är vanligt förekommande på
Folkmusikkaféet, men också på danshus, spelmansstämmor och folkmusikfestivaler i hela
Sverige. Detta är en nybörjarkurs men alla som vill är välkomna.<br/><br/>
Medtag skor som har sulor ”med glid”.<br/><br/>
Kursinstruktörer: Mats Nilsson och Ingegerd Sigfridsson<br/>
      Spelman: Staffan Folestad<br/><br/>
      Kursavgift 400 kr (ung & stud 200 kr)<br/><br/>
(Om du vill vara bättre förberedd inför kursen så är du välkommen till våra dansstugor i
  polska och schottis 19/1 och 26/1.)<br/><br/>


  </div>
  </center>
<br/><br/>
<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfGsB-VZIMyuN3w61UHEsGD02U_Wa_5CpgkLMBSS0WiMdDfYw/viewform?embedded=true" width="95%" height="1000px" frameborder="0" marginheight="0" marginwidth="0">Läser in …</iframe>
<br/>
<br/>


<br/>
<br/>
<center><img className="kursbild fade-in-fast" src="img/tillsammansgruppen.jpg"></img></center><br/>
<center><h3>Tillsammansgruppen</h3></center>
<center>
<div className="kompakt">
Genom alla tider har vi lekt på fest och till vardags, barn som vuxen.<br/>
Tillsammansgruppen ger dig möjlighet att ta del av denna roliga tradition.<br/>
Stora som små är varmt välkomna att hänga med i vindlande långdanser och visor.<br/>
Det är motion för både kropp som knopp!
<br/><br/>
Tider: 18:00 till 19:30 med tid för fika.<br/>
Instruktörer: Gunnel Sjögren och Gunilla Sellersjö <br/>
Datum: 19/1, 15/3, 5/4<br/>
Kostnad: Gratis <br/>
För barn i sällskap med någon vuxen<br/>
</div>
</center>
</div>
</center>
      );
  }

}


export default Kurser;





